import React from 'react';
import FlexBoxPlayground from './FlexBoxPlayground/FlexBoxPlayground';
import './App.css';

const App = () => (
  <div className="App">
    <FlexBoxPlayground className="playground" />
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx